import clsx from "clsx";
import type { ReactNode } from "react";

// Shared by CodeBlock and LazyCodeBlock's plain-text fallback. Must not import Prism, because
// LazyCodeBlock is part of every page with code and keeps Prism out of the initial bundle.

export type CodeValue = {
  code: string;
  filename?: string;
  language?: string;
  highlightedLines?: Array<number>;
};

export type CodeBlockProps = {
  fullSize?: boolean;
  code: CodeValue | string;
  language?: string;
  filename?: string;
  highlightedLines?: Array<number>;
  actions?: Array<any>;
  maxHeight?: number;
  className?: string;
  footer?: ReactNode;
};

const languageMap: Record<string, string> = { golang: "go", mysql: "sql" };

export function normalizeCodeValue({
  code: codeProp,
  language,
  filename,
  highlightedLines,
}: CodeBlockProps): Required<Omit<CodeValue, "filename" | "language">> &
  Pick<CodeValue, "filename" | "language"> {
  const value: CodeValue =
    typeof codeProp === "string"
      ? { code: codeProp, language, filename, highlightedLines }
      : codeProp;
  return {
    code: value.code ?? "",
    filename: value.filename,
    language: languageMap[value.language ?? ""] ?? value.language,
    highlightedLines: value.highlightedLines ?? [],
  };
}

export function codeBlockWrapperClassName(fullSize?: boolean, className?: string) {
  return clsx(
    "bg-grey-900/50 rounded-lg mt-4 mb-4 relative group",
    fullSize ? "col-span-full" : "blog-text-wrapper blog-paragraph-wrapper",
    className,
  );
}

export function codeBlockLanguageLabel(language: unknown) {
  if (typeof language !== "string") return "text";
  return language === "javascript" ? "JavaScript" : language;
}

export function codeBlockMaxHeight(maxHeight?: number) {
  return maxHeight ? maxHeight - 50 + "px" : "auto";
}
